import { useContext } from 'react';
import { ArrearsUser } from 'Feature/Arrears/components/ArrearsInquiryPage/core/users/ArrearsUser';
import { ArrearsUserContext } from 'Feature/Arrears/components/ArrearsInquiryPage/core/users/ArrearsUserProvider';

export const useArrearsUser = (): ArrearsUser => useContext(ArrearsUserContext);
